import { DepartmentDto } from "../../autogen/bff-api";
import { requireBooleanEnvVar } from "../../config";

export const organizationHasSeveralDepartments = (org: { departments?: DepartmentDto[] }): boolean =>
  (org.departments ?? []).length > 1;

// BFF Profiles.kt gates PUBLISH on HomeDepartmentPresent: hide an unset one and the draft is stuck.
export const showsHomeDepartment = (
  org: { departments?: DepartmentDto[] },
  homeDepartmentId: string | null | undefined
): boolean => organizationHasSeveralDepartments(org) || !homeDepartmentId;

export const departmentsAreEnabled = (): boolean => requireBooleanEnvVar("VITE_ENABLE_DEPARTMENTS");

export const showsProjectDepartment = (org: { departments?: DepartmentDto[] }): boolean =>
  departmentsAreEnabled() && organizationHasSeveralDepartments(org);
